// Ausserbetriebsetzung

// state
const state = {
    lastTankRevision: '',
    lastBoilerEntkalkung: '',
    sweepstakeTermsAccepted: false,
}

// getters
const getters = {
}

// actions
const actions = {

}

// mutations
const mutations = {
    setLastTankRevision(state, newValue) {
        state.lastTankRevision = newValue;
    },
    setLastBoilerEntkalkung(state, newValue) {
        state.lastBoilerEntkalkung = newValue;
    },
    setSweepstakeTermsAccepted(state, newValue) {
        state.sweepstakeTermsAccepted = newValue;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}